import { ReactNode } from 'react'

import { LargeHeading } from './headingPrimitives'
import { StandardHeading } from './StandardHeading'

export interface SecondaryHeadingProps {
  header: string
  headerCaption?: ReactNode
  id?: string
  tagName?: 'h2' | 'h3'
  bodyText?: ReactNode
  additionalText?: ReactNode
  leadText?: ReactNode
}

export const SecondaryHeading = ({ header, id, tagName = 'h2', ...rest }: SecondaryHeadingProps) => {
  return (
    <StandardHeading
      header={
        <LargeHeading tagName={tagName} id={id}>
          {header}
        </LargeHeading>
      }
      {...rest}
    />
  )
}
